import script from "./skeletonRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./skeletonRow.vue?vue&type=script&setup=true&lang=ts"

import "./skeletonRow.vue?vue&type=style&index=0&id=bc4cd0e0&lang=css"

const __exports__ = script;

export default __exports__